import { CallSignalingService, CallSignal } from 'src/app/services/calls/call-signaling.service';

import { Platform , ModalController, NavController, GestureController } from '@ionic/angular';
//import { StatusBar } from '@ionic-native/status-bar/ngx';
//import { BackgroundMode } from '@ionic-native/background-mode/ngx';

//import { ForegroundService } from '@ionic-native/foreground-service/ngx';
import { Component, NgZone, ApplicationRef, HostListener,ViewChild } from '@angular/core';
import { ActualizacionServiceService } from 'src/app/services/actualizacion/Actualizacion-service.service';
import { LkfilmViewBySlidesComponent } from 'src/app/components/lkfilm-view-by-slides/lkfilm-view-by-slides.component';
//import { Deeplinks } from '@ionic-native/deeplinks/ngx';
import { App, URLOpenListenerEvent } from '@capacitor/app';


/*
  import { ToastController } from '@ionic/angular';
import { NotificationService } from './services/notifications/notification.service';
import {
	ActionPerformed,
	PushNotificationSchema,
	PushNotifications,
	Token,
  } from '@capacitor/push-notifications';
   const { LocalNotifications } = Plugins;
     import { Plugins } from '@capacitor/core';
	   import { FirebaseApp } from '@angular/fire';
  import * as firebase from 'firebase';
  import * as models from 'src/app/Models/Classes/graphql/models/models-graphql';
  import { CreateUserInput } from 'src/app/Models/Classes/graphql/models/models-graphql';
  import { Console } from 'console';
    import { Utils } from 'src/app/Models/Classes/utils';
	  import { Router } from '@angular/router';
	  import { GraphQLAPIService } from 'src/app/services/request/GraphQl-Api.service';
	    import { Title } from '@angular/platform-browser';
  import { Meta } from '@angular/platform-browser';*/



 
  import { InAppPurchase2,IAPProduct } from '@awesome-cordova-plugins/in-app-purchase-2/ngx';
  import  Swal from 'sweetalert2';
  import { SplashScreen } from '@capacitor/splash-screen';
  import { FormServiceService } from 'src/app/services/publications/form-service.service';

  import { Capacitor } from '@capacitor/core';

  import { ProfileService } from 'src/app/services/profile/profile.service';


  import { Howl } from 'howler';

  import { Device } from '@capacitor/device';
  import { Network } from '@capacitor/network';
  import { HttpClient } from '@angular/common/http';
  import { RequestService } from 'src/app/services/request/request.service';
import { Browser } from '@capacitor/browser';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {PrivacyScreen}from '@capacitor-community/privacy-screen';
import{ContentPreferencesComponent}from'src/app/content-preferences/content-preferences.component';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Event as RouterEvent } from '@angular/router';
import { RouterOutlet, Router, ActivationStart } from '@angular/router'
import { UploadMultimediaService } from 'src/app/services/upload/upload-multimedia.service';
import { setupGlobalLeftToRightModalDismiss } from 'src/app/utils/enable-left-to-right-swipe-dismiss';
import { NativeLiquidGlass, NativeCalls, NativeCallEvent, NativeLiveActivities, NativeSpotlight, NativeAudioPlayback } from 'src/app/plugins/native-runtime.plugins';
import { ActionPerformed, PushNotifications, PushNotificationSchema, Token } from '@capacitor/push-notifications';
import { SecureOperationFeedbackService } from 'src/app/services/ui/secure-operation-feedback.service';
import { DeferredWebFirebaseService } from 'src/app/services/startup/deferred-web-firebase.service';
import { HapticLanguageService } from 'src/app/services/ui/haptic-language.service';
import { AppQualityService } from 'src/app/services/quality/app-quality.service';
import { AppNavigationStateService, ExternalNavigationSource } from 'src/app/services/startup/app-navigation-state.service';
var MediaRecorder;
//import { NgxSmartBannerService, NgxSmartBannerPlatform } from '@netcreaties/ngx-smart-banner';
//import { ViewContainerRef } from '@angular/core';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss']
})
export class AppComponent {
	private nativeSwalChromeObserver?: MutationObserver;
	private nativeSwalChromeFrame = 0;
	private nativeSwalChromeMetricsRequest = 0;
	private nativeSwalChromeSignature = '';
	private readonly nativeSwalChromeResize = (): void => this.scheduleNativeSwalChromeMetrics(true);
	private readonly nativeHeaderBodyClasses = [
		'native-liquid-header',
		'native-eventos-header',
		'native-hospedaje-header',
		'native-dropship-header',
	];
	private readonly nativeFooterBodyClasses = [
		'native-liquid-footer',
		'native-dropship-footer',
		'mycelium-native-footer',
		'lia-collabs-native-footer',
	];
	private readonly dismissLightningLoaderOnTap = (event: MouseEvent): void => {
		const loading = event.composedPath().find((target): target is HTMLIonLoadingElement =>
			(target as HTMLElement).tagName === 'ION-LOADING',
		);
		if (loading && String(loading.message || '').replace(/\uFE0F/g, '') === '⚡⚡⚡') {
			void loading.dismiss().catch(() => undefined);
		}
	};
	private readonly nativeChromeReconciliationEvent = 'laniakea:native-chrome-reconcile';
	private nativeChromeReconciliationTimers: Array<ReturnType<typeof setTimeout>> = [];
	private readonly requestNativeChromeReconciliation = (): void => {
		this.scheduleNativeChromeReconciliation();
	};
	private startupSdkLoads = new Map<string, Promise<void>>();
	// The native launch animation is already visible before Angular gets its first
	// turn. Starting this request from the root component lets the authenticated
	// profile arrive while that animation is still on screen, rather than making
	// the loader wait for an additional post-render delay.
	private startupProfileWarmup?: Promise<any>;
	private recoveringNavigationError = false;
	private pushTokenPersistenceInitialized = false;
	private universalNavigationInitialized = false;
	private oauthCallbackHandledAt = 0;
	private readonly openIonicMenus = new Set<EventTarget>();
	private readonly nativePublicationOverlays = new Set<EventTarget>();
	private nativePublicationNavigationPending = false;
	private readonly nativePublicationOverlayWillPresent = (event: Event): void => {
		const overlay = this.ionicOverlayTarget(event);
		if (overlay) this.nativePublicationOverlays.add(overlay);
		this.suspendNativePublicationInformation(false);
	};
	private readonly nativePublicationOverlayDidPresent = (event: Event): void => {
		const overlay = this.ionicOverlayTarget(event);
		if (overlay) this.nativePublicationOverlays.add(overlay);
		this.suspendNativePublicationInformation(false);
	};
	private readonly nativePublicationOverlayDidDismiss = (event: Event): void => {
		const overlay = this.ionicOverlayTarget(event);
		if (overlay) this.nativePublicationOverlays.delete(overlay);
		this.removeDisconnectedNativePublicationOverlays();
		if (!this.nativePublicationNavigationPending && this.nativePublicationOverlays.size === 0) {
			this.restoreNativePublicationInformationContext();
		}
	};
	private readonly nativeMenuWillOpen = (event: Event): void => {
		const menu = this.ionicMenuTarget(event);
		if (!menu) return;
		this.openIonicMenus.add(menu);
		NativeLiquidGlass.setChromeSuppressed({ suppressed: true }).catch(() => undefined);
	};
	private readonly nativeMenuDidOpen = (event: Event): void => {
		const menu = this.ionicMenuTarget(event);
		if (!menu) return;
		this.openIonicMenus.add(menu);
		NativeLiquidGlass.setChromeSuppressed({ suppressed: true }).catch(() => undefined);
	};
	private readonly nativeMenuDidClose = (event: Event): void => {
		const menu = this.ionicMenuTarget(event);
		if (menu) {
			this.openIonicMenus.delete(menu);
		}
		if (this.openIonicMenus.size === 0) {
			NativeLiquidGlass.setChromeSuppressed({ suppressed: false }).catch(() => undefined);
		}
	};

	private readonly seenIncomingCalls = new Map<string, number>();
	private webIncomingCallUUID?: string;
	public videoUpgradeRequest?: CallSignal;
	private videoUpgradeTimer?: ReturnType<typeof setTimeout>;
	private readonly requestedNativeVideo = new Set<string>();

	private initializeCallSignaling(): void {
		this.callSignaling.events.subscribe(call => { void this.handleCallSignal(call).catch(console.warn); });
		window.addEventListener('laniakea:call-session-ready', () => {
			this.callSignaling.stop();
			this.seenIncomingCalls.clear();
			void this.callSignaling.start('signed-in session ready').catch(console.warn);
		});
		window.addEventListener('laniakea:call-session-ended', () => {
			this.callSignaling.stop();
			this.seenIncomingCalls.clear();
			if (this.webIncomingCallUUID) Swal.close();
			this.webIncomingCallUUID = undefined;
		});
		void App.addListener('appStateChange', state => {
			if (state.isActive) void this.callSignaling.reconcile('app became active').catch(console.warn);
		});
		document.addEventListener('visibilitychange', () => {
			if (document.visibilityState === 'visible') void this.callSignaling.reconcile('page became visible').catch(console.warn);
		});
	}

	private async handleCallSignal(call: CallSignal): Promise<void> {
		if (call.status === 'video_requested') {
			this.videoUpgradeRequest = call;
			if (this.videoUpgradeTimer) clearTimeout(this.videoUpgradeTimer);
			this.videoUpgradeTimer = setTimeout(() => this.dismissVideoUpgrade(), 30000);
			void this.hapticLanguage.warning();
			return;
		}
		if (!call.is_recipient) return;
		if (call.status !== 'ringing') {
			if (this.webIncomingCallUUID === call.uuid) {
				this.webIncomingCallUUID = undefined;
				Swal.close();
			}
			return;
		}
		const now = Date.now() / 1000;
		for (const [uuid, expiry] of this.seenIncomingCalls) {
			if (expiry <= now) this.seenIncomingCalls.delete(uuid);
		}
		if (call.expires_at <= now || this.seenIncomingCalls.has(call.uuid)) return;
		this.seenIncomingCalls.set(call.uuid, call.expires_at);
		if (Capacitor.getPlatform() === 'ios' && Capacitor.isPluginAvailable('NativeCalls')) {
			try {
				const { calls } = await NativeCalls.getPending();
				if (!calls.some(value => value.uuid === call.uuid)) {
					await NativeCalls.openIncoming({ meeting_id: call.meeting_id, answer: false });
				}
			} catch (error) {
				this.seenIncomingCalls.delete(call.uuid);
				throw error;
			}
			return;
		}
		if (this.webIncomingCallUUID) return;
		this.webIncomingCallUUID = call.uuid;
		const result = await Swal.fire({
			title: call.has_video ? 'Videollamada entrante' : 'Llamada entrante',
			showCancelButton: true, confirmButtonText: 'Contestar', cancelButtonText: 'Declinar',
			timer: Math.max(1, (call.expires_at - now) * 1000), allowOutsideClick: false,
		});
		if (this.webIncomingCallUUID !== call.uuid) return;
		this.webIncomingCallUUID = undefined;
		if (result.isConfirmed) {
			await this.request.createRequestPost('iosCall', {
				action: 'answer', meeting_id: call.meeting_id, token: this.callSignaling.deviceToken,
			});
			await this.navCtrl.navigateRoot(`/chime-contact?incoming_call=true&meeting_id=${encodeURIComponent(call.meeting_id)}`, { replaceUrl: true });
		} else if (result.dismiss === Swal.DismissReason.cancel) {
			await this.request.createRequestPost('iosCall', { action: 'reject', meeting_id: call.meeting_id });
		}
	}

	public dismissVideoUpgrade(): void {
		this.videoUpgradeRequest = undefined;
		if (this.videoUpgradeTimer) clearTimeout(this.videoUpgradeTimer);
		this.videoUpgradeTimer = undefined;
	}

	public async acceptVideoUpgrade(): Promise<void> {
		const call = this.videoUpgradeRequest;
		this.dismissVideoUpgrade();
		if (!call) return;
		if (Capacitor.getPlatform() === 'ios' && Capacitor.isPluginAvailable('NativeCalls')) {
			const { calls } = await NativeCalls.getPending();
			const native = calls.find(value => value.meeting_id === call.meeting_id && value.action === 'answer');
			if (native) {
				this.nativeVideoContinuation = undefined;
				await this.handleNativeCallEvent({ ...native, action: 'video' });
				return;
			}
		}
		if (this.router.url.includes('chime-contact') || this.router.url.includes('/calls/active/')) {
			const camera = document.querySelector('app-chime-contact #button-camera') as HTMLButtonElement | null;
			if (camera && camera.getAttribute('aria-pressed') !== 'true') camera.click();
		} else {
			await this.navCtrl.navigateRoot(`/chime-contact?incoming_call=true&meeting_id=${encodeURIComponent(call.meeting_id)}&videoUpgrade=true`);
		}
	}

	private activeNativeCallUUID?: string;
	public nativeVideoContinuation?: NativeCallEvent;
	private readonly openingNativeCalls = new Set<string>();

	public async continueNativeCallWithVideo(): Promise<void> {
		const call = this.nativeVideoContinuation;
		if (!call) return;
		this.nativeVideoContinuation = undefined;
		await this.handleNativeCallEvent({ ...call, action: 'video' });
	}

	public nativeCallMuted = false;
	public nativeCallSpeakerEnabled = false;

	public async toggleNativeCallMute(): Promise<void> {
		const call = this.nativeVideoContinuation;
		if (!call?.uuid) return;
		const muted = !this.nativeCallMuted;
		this.nativeCallMuted = muted;
		try {
			await NativeCalls.setMuted({ uuid: call.uuid, muted });
		} catch (error) {
			this.nativeCallMuted = !muted;
			console.warn('Could not update native call mute state:', error);
		}
	}

	public async toggleNativeCallSpeaker(): Promise<void> {
		const call = this.nativeVideoContinuation;
		if (!call?.uuid) return;
		const speaker_enabled = !this.nativeCallSpeakerEnabled;
		this.nativeCallSpeakerEnabled = speaker_enabled;
		try {
			await NativeCalls.setSpeaker({ uuid: call.uuid, speaker_enabled });
		} catch (error) {
			this.nativeCallSpeakerEnabled = !speaker_enabled;
			console.warn('Could not change native call audio route:', error);
		}
	}

	public async endNativeCall(): Promise<void> {
		const call = this.nativeVideoContinuation;
		if (!call?.uuid) return;
		try {
			await NativeCalls.end({ uuid: call.uuid });
		} catch (error) {
			console.warn('Could not end native call from in-app controls:', error);
		}
	}

	private async initializeNativeCalls(): Promise<void> {
		if (Capacitor.getPlatform() !== 'ios' || !Capacitor.isPluginAvailable('NativeCalls')) return;
		await NativeCalls.addListener('callEvent', event => {
			this.zone.run(() => { void this.handleNativeCallEvent(event); });
		});
		let recovery: Promise<void> | null = null;
		const recover = async () => {
			if (recovery) return recovery;
			recovery = (async () => {
				// Keep answered calls on native audio. CallKit foregrounds the app
				// for its video control but provides no distinct delegate action for it.
				// Offer an explicit continuation instead of interrupting every call.
				const appState = await App.getState();
				const { calls } = await NativeCalls.getPending();
				const active = new Set(calls.map(call => call.uuid));
				if (this.nativeVideoContinuation && !active.has(this.nativeVideoContinuation.uuid)) {
					this.nativeVideoContinuation = undefined;
					this.nativeCallMuted = false;
					this.nativeCallSpeakerEnabled = false;
				}
				if (this.activeNativeCallUUID && !active.has(this.activeNativeCallUUID)) {
					await this.closeNativeCallPage(this.activeNativeCallUUID);
				}
				for (const call of calls) {
					if (appState.isActive && call.action === 'answer'
						&& this.router.url.split('?')[0] !== `/calls/active/${encodeURIComponent(call.uuid)}`) {
						this.nativeVideoContinuation = call;
						this.nativeCallMuted = call.muted ?? false;
						this.nativeCallSpeakerEnabled = call.speaker_enabled ?? false;
					}
					await this.handleNativeCallEvent(call);
				}
				void NativeCalls.refreshRegistration().catch(console.warn);
			})().finally(() => { recovery = null; });
			return recovery;
		};
		await App.addListener('appStateChange', state => {
			if (state.isActive) this.zone.run(() => { void recover().catch(console.warn); });
		});
		await App.addListener('resume', () => {
			this.zone.run(() => { void recover().catch(console.warn); });
		});
		await recover();
	}

	private async handleNativeCallEvent(event: NativeCallEvent): Promise<void> {
		const uuid = event.uuid;
		if (!uuid) return;
		if (event.action === 'answer') {
			if (this.router.url.split('?')[0] === `/calls/active/${encodeURIComponent(uuid)}`) return;
			this.nativeVideoContinuation = event;
			this.nativeCallMuted = event.muted ?? false;
			this.nativeCallSpeakerEnabled = event.speaker_enabled ?? false;
			return;
		}
		if (event.action === 'mute') {
			if (!this.nativeVideoContinuation || this.nativeVideoContinuation.uuid === uuid) {
				this.nativeCallMuted = event.muted ?? this.nativeCallMuted;
			}
			return;
		}
		if (event.action === 'audioRouteChanged') {
			if (!this.nativeVideoContinuation || this.nativeVideoContinuation.uuid === uuid) {
				this.nativeCallSpeakerEnabled = event.speaker_enabled ?? this.nativeCallSpeakerEnabled;
			}
			return;
		}
		if (event.action === 'end') {
			if (this.nativeVideoContinuation?.uuid === uuid) {
				this.nativeVideoContinuation = undefined;
				this.nativeCallMuted = false;
				this.nativeCallSpeakerEnabled = false;
			}
			await this.closeNativeCallPage(uuid);
			return;
		}
		// Answering stays on the native CallKit/Chime path. Only a dedicated
		// video action may hand the call over to the Angular meeting page.
		if (event.action !== 'video' || !event.meeting_id
			|| this.openingNativeCalls.has(uuid)) return;
		this.openingNativeCalls.add(uuid);
		try {
			if (!(await App.getState()).isActive) return;
			const { calls } = await NativeCalls.getPending();
			const answeredCall = calls.find(call => call.uuid === uuid && call.action === 'answer');
			if (!answeredCall) return;
			const meetingId = answeredCall.meeting_id || event.meeting_id;
			if (!answeredCall.has_video && !this.requestedNativeVideo.has(uuid)) {
				try {
					await this.request.createRequestPost('iosCall', { action: 'request_video', meeting_id: meetingId });
					this.requestedNativeVideo.add(uuid);
				} catch (error) {
					console.warn('Could not notify the other participant about video:', error);
				}
			}
			// Mount the meeting page first. It verifies the active native call and
			// releases CallKit before requesting any WebKit media.
			const route = `/chime-contact?incoming_call=true&meeting_id=${encodeURIComponent(meetingId)}`
				+ `&videoUpgrade=true&nativeHandoffUUID=${encodeURIComponent(uuid)}`;
			if (!(await this.navCtrl.navigateRoot(route, { replaceUrl: true }))) {
				throw new Error('Could not navigate to the call page');
			}
		} catch (error) {
			console.warn('Could not open requested iOS video call:', error);
		} finally {
			this.openingNativeCalls.delete(uuid);
		}
	}

	private async closeNativeCallPage(uuid: string): Promise<void> {
		if (this.nativeVideoContinuation?.uuid === uuid) this.nativeVideoContinuation = undefined;
		this.requestedNativeVideo.delete(uuid);
		if (this.activeNativeCallUUID === uuid) this.activeNativeCallUUID = undefined;
		if (this.router.url.split('?')[0] === `/calls/active/${encodeURIComponent(uuid)}`) {
			await this.navCtrl.navigateRoot('/home/ecosystem-page', { replaceUrl: true });
		}
	}

	private initializeGlobalPushTokenPersistence(): void {
		if (this.pushTokenPersistenceInitialized || Capacitor.getPlatform() !== 'ios') return;
		this.pushTokenPersistenceInitialized = true;
		void this.initializeNativeCalls().catch(error => console.warn("iOS call initialization failed:", error));

		PushNotifications.addListener('registration', (token: Token) => {
			const deviceToken = token?.value?.trim();
			if (!deviceToken) return;

			this.profileService.getProfileInfo()
				.then(profileResponse => {
					const profile = typeof profileResponse === 'string'
						? JSON.parse(profileResponse)
						: profileResponse;
					if (!profile?.id) return;
					if (Capacitor.isPluginAvailable('NativeCalls')) void NativeCalls.refreshRegistration().catch(console.warn);

					return this.request.createRequestPost('saveDeviceToken', {
						device_token: deviceToken,
						profile_id: profile.id,
						device_platform: 'ios',
					});
				})
				.catch(error => {
					// NativeStorage code 2 means AccessDataUser does not exist.
					// That is the normal logged-out/guest state: Firebase may keep
					// its token locally, but there is no profile to associate yet.
					if (error?.source === 'Native' && Number(error?.code) === 2) return;
					console.warn('Could not persist refreshed iOS FCM token:', error);
				});
		});

		PushNotifications.addListener('registrationError', error => {
			console.warn('iOS push registration failed:', error);
		});

		PushNotifications.requestPermissions()
			.then(permission => {
				if (permission.receive === 'granted') return PushNotifications.register();
				return undefined;
			})
			.catch(error => console.warn('Could not register iOS push notifications:', error));
	}

	private loadStartupScript(src: string): Promise<void> {
		const activeLoad = this.startupSdkLoads.get(src);
		if (activeLoad) return activeLoad;

		const load = new Promise<void>((resolve, reject) => {
			const existing = document.querySelector(`script[src="${src}"]`) as HTMLScriptElement | null;
			if (existing?.dataset['laniakeaLoaded'] === 'true') {
				resolve();
				return;
			}

			const script = existing || document.createElement('script');
			script.src = src;
			script.async = true;
			script.onload = () => {
				script.dataset['laniakeaLoaded'] = 'true';
				resolve();
			};
			script.onerror = () => reject(new Error(`Unable to load startup SDK: ${src}`));
			if (!existing) document.head.appendChild(script);
		});

		this.startupSdkLoads.set(src, load);
		return load;
	}

	private initializeStartupSdks(): void {
		const googleMaps = (window as any).google?.maps
			? Promise.resolve()
			: this.loadStartupScript(
				'https://maps.googleapis.com/maps/api/js?key=AIzaSyDKzCRYNscPNGWIGhsVZdFk-q-QuQmDjEs&libraries=places&loading=async'
			);
		const stripe = this.loadStartupScript('https://js.stripe.com/v3/').then(() => {
			const StripeRuntime = (window as any).Stripe;
			if (!StripeRuntime) throw new Error('Stripe.js loaded without exposing Stripe.');

			// Preserve the globals that index.html historically initialized. Core
			// payment screens can still create client-secret-specific Elements later.
			const stripeClient = StripeRuntime('pk_live_51KGxgHCVJMP5YqiYzADXUzozYAEmRFPrTkPzRacQ3EELXgN05NVG1GvklRwKtAif5ijbqavUn0Qw4d7ygGQEf7E600LtFRhx6k');
			(window as any).stripe = stripeClient;
			(window as any).elements = stripeClient.elements();
		});

		const googlePicker = this.loadStartupScript('https://apis.google.com/js/api.js').then(() => {
			const gapi = (window as any).gapi;
			if (!gapi) throw new Error('Google API loaded without exposing gapi.');

			return new Promise<void>((resolve, reject) => {
				gapi.load('picker', {
					callback: () => {
						(window as any).googlePickerReady = true;
						resolve();
					},
					onerror: () => reject(new Error('Google Picker module failed to initialize.')),
					timeout: 15000,
					ontimeout: () => reject(new Error('Google Picker module initialization timed out.'))
				});
			});
		});

		const openPay = this.loadStartupScript('https://ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js')
			.then(() => this.loadStartupScript('https://js.openpay.mx/openpay.v1.min.js'))
			.then(() => this.loadStartupScript('https://js.openpay.mx/openpay-data.v1.min.js'))
			.then(() => {
				const OpenPay = (window as any).OpenPay;
				if (OpenPay) {
					OpenPay.setId('moljimj06bosrtpbhj7r');
					OpenPay.setApiKey('pk_0b4026fe78b64640a32664d0034b6292');
				}
			});

		Promise.all([googleMaps, stripe, googlePicker, openPay]).catch(error => {
			console.error('A startup SDK failed to initialize:', error);
		});
	}

	private scheduleAfterFirstRender(task: () => void, delay = 0): void {
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				setTimeout(task, delay);
			});
		});
	}

	private scheduleIdleTask(task: () => void, timeout = 4000): void {
		const idleCallback = (window as any).requestIdleCallback;
		if (typeof idleCallback === 'function') {
			idleCallback(task, { timeout });
			return;
		}
		setTimeout(task, Math.min(timeout, 2000));
	}

	//private appStoreUrl = 'https://itunes.apple.com/lookup?bundleId=com.yourcompany.laniakea'; // Update this!
	private redirectPath = '/waiting-page'; // Angular route
	@ViewChild(RouterOutlet) outlet: RouterOutlet;
	screenshotCombinationPressed:boolean=false;
	laniakea_tv_loaded:boolean=false;
	allowScrolling:boolean=false;
	pr:any
	public MEETING_ID_KEY: any;
	public publications: any[] = [];
	productId2: string = '1618';
	public SubscriptionExpired: boolean =true;
	public isOffline = false;
	public readonly isWebPlatform = Capacitor.getPlatform() === 'web';
	constructor( 
		private platform: Platform,
		//private statusBar: StatusBar,
		//private backgroundMode: BackgroundMode,
		//private notificationsService: NotificationService,
		//public foregroundService: ForegroundService,
		private actualizacionservice:ActualizacionServiceService,
		private modalctrl:ModalController,
		private zone: NgZone,
		//private toastController: ToastController,
		private store: InAppPurchase2,
		private formService:FormServiceService,
		//private router: Router,
		//private utils: Utils,
		private profileService: ProfileService,
		//private Api: GraphQLAPIService,
		private navCtrl: NavController,
		private http: HttpClient,
		//private metaService: Meta,
		//private titleService: Title,
		private request: RequestService,
		private sanitizer: DomSanitizer,
		private ngZone: NgZone,
		private router: Router,
		public uploadMultimedia: UploadMultimediaService,
		//private readonly ngxSmartBannerService: NgxSmartBannerService,
	//	private readonly viewContainerRef: ViewContainerRef,
		private gestureCtrl: GestureController,
		private secureFeedback: SecureOperationFeedbackService,
		private deferredWebFirebase: DeferredWebFirebaseService,
		private hapticLanguage: HapticLanguageService,
		private appQuality: AppQualityService,
		private navigationState: AppNavigationStateService,
		private callSignaling: CallSignalingService,
	) {
		document.addEventListener('click', this.dismissLightningLoaderOnTap, true);
		const isNativeIos = Capacitor.getPlatform() === 'ios';
		this.appQuality.initialize();
		this.installNavigationQualityTracking();
		this.hapticLanguage.installGlobalFeedback();
		document.body.classList.toggle('is-native-ios', isNativeIos);
		if (isNativeIos) {
			this.installNativeSwalChromeTracking();
			document.getElementById('liquid-refraction-definitions')?.remove();
			document.addEventListener('ionWillOpen', this.nativeMenuWillOpen, true);
			document.addEventListener('ionDidOpen', this.nativeMenuDidOpen, true);
			document.addEventListener('ionDidClose', this.nativeMenuDidClose, true);
			this.bindNativePublicationOverlayLifecycle();
		} else {
			this.secureFeedback.begin('Iniciando Laniakea');
		}
		if (isNativeIos) {
			// AppDelegate has already begun its native logo animation by the time
			// JavaScript can run. This is therefore the earliest safe place to use
			// the Capacitor-authenticated profile endpoint.
			this.startProfileWarmup().catch(() => undefined);
		}
		this.initializeCallSignaling();
		this.initializeApp();
		// Do not compete with WebKit/Angular while the native launch screen is up.
		// Two animation frames guarantee that app-root has painted before we hide
		// the splash or begin optional SDK/network/audio work.
		this.scheduleAfterFirstRender(() => {
			if (isNativeIos) {
				// This is the first point at which the WebView has committed actual
				// Angular frames. It completes the native startup animation and also
				// releases native services that were intentionally kept off the launch
				// path while WebKit created its content, networking and GPU processes.
				NativeLiquidGlass.markWebViewReady().catch(error => {
					console.warn('Could not complete native startup feedback', error);
				});
			}
			this.SplashScreen().finally(() => {
				if (!isNativeIos) {
					// Wait for the fallback component to exist in the painted DOM, then
					// begin its real CSS success sequence. Its animationend event owns
					// dismissal; there is intentionally no visibility timeout here.
					this.secureFeedback.begin('Preparando tu espacio');
					requestAnimationFrame(() => requestAnimationFrame(() => {
						this.secureFeedback.succeedIfCurrent(
							'Preparando tu espacio',
							'Laniakea lista'
						);
					}));
				}
			});
			this.scheduleIdleTask(() => this.initializeGlobalPushTokenPersistence(), 1800);
			this.scheduleIdleTask(() => this.initializeStartupSdks(), 3000);
			this.scheduleIdleTask(() => this.deferredWebFirebase.initialize(), 3500);
		}, 0);
		if (isNativeIos) {
			// A slide can replace an Ionic page without a router transition. Treat
			// it as a chrome hand-off just like navigation so UIKit never retains
			// the previous page's glass above the newly active page.
			document.addEventListener('ionSlideWillChange', this.requestNativeChromeReconciliation, true);
			document.addEventListener('ionSlideDidChange', this.requestNativeChromeReconciliation, true);
			document.addEventListener('ionViewWillEnter', this.requestNativeChromeReconciliation, true);
			document.addEventListener('ionViewDidEnter', this.requestNativeChromeReconciliation, true);
			this.router.events.subscribe(event => {
				if (event instanceof NavigationStart) {
					// The startup checkmark lives in a native overlay window. If a
					// route change begins while its final animation is still around,
					// dismiss it immediately so it cannot remain frozen above the next
					// page. The initial navigation is excluded so the launch feedback
					// can still complete normally.
					if (this.router.navigated) {
						NativeLiquidGlass.dismissStartupFeedback().catch(() => undefined);
					}
					this.nativePublicationNavigationPending = true;
					this.suspendNativePublicationInformation(true);
				}
				if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
					this.nativePublicationNavigationPending = false;
					this.removeDisconnectedNativePublicationOverlays();
					if (event instanceof NavigationEnd) {
						this.synchronizeRouteNativeChrome(event.urlAfterRedirects);
						this.scheduleNativeChromeReconciliation();
					}
					const keepPublicationSuppressed = event instanceof NavigationEnd
						&& !this.canRestoreNativePublicationInformation(event.urlAfterRedirects);
					if (this.nativePublicationOverlays.size === 0 && !keepPublicationSuppressed) {
						this.restoreNativePublicationInformationContext();
					}
				}
				if (event instanceof NavigationStart && this.isHubbleRoute(event.url)) {
					this.secureFeedback.begin('Abriendo Hubble');
				}
				if (event instanceof NavigationEnd && this.isHubbleRoute(event.urlAfterRedirects)) {
					this.secureFeedback.succeedIfCurrent(
						'Abriendo Hubble',
						'Hubble preparado'
					);
				}
			});
			App.addListener('appStateChange', ({ isActive }) => {
				if (isActive) this.restoreNativeOverlays();
			}).catch(() => undefined);
			window.addEventListener('focus', () => this.restoreNativeOverlays());
			window.addEventListener('pageshow', () => this.restoreNativeOverlays());
		}


		document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
		this.router.events.subscribe(e => {
			if (e instanceof ActivationStart && e.snapshot.outlet === 'administration') {
				this.outlet.deactivate();
			}
		});
		this.router.events.subscribe((event: RouterEvent) => {
			if (event instanceof NavigationError) {
			  console.error('NavigationError Event:', event.error, event, event.url);
			  const failedPath = (event.url || '').split('?')[0].replace(/\/+$/, '') || '/';

			  // Never navigate to /loader from a failed /loader navigation. Router is
			  // configured to reload same-URL navigations, so that recovery used to
			  // recreate LoaderPage indefinitely during a cold start.
			  if (failedPath === '/loader' || this.recoveringNavigationError) {
				return;
			  }

			  this.recoveringNavigationError = true;
			  this.router.navigateByUrl('/home/ecosystem-page', { replaceUrl: true })
				.catch(recoveryError => console.error('Navigation recovery failed:', recoveryError))
				.finally(() => { this.recoveringNavigationError = false; });
			}
		  });
		  /*
		  if (!this.platform.is('ios')) {

		  this.ngxSmartBannerService.initialize({

			priceSuffix:{
				ios:' App Store',

			},
			icon:{
			ios:'https://static.wixstatic.com/media/8c5863_fdaf95eada5f48ff8020db461960ace2~mv2.png'
			},
			buttonUrl:{
				ios:'https://apps.apple.com/mx/app/laniakea/id1660407742?l=en-GB'
			},
			title: 'Laniakea',
			author: 'Laniakea Technologies',
			enabledPlatforms: [NgxSmartBannerPlatform.IOS],
			rating: {
			  ios: 5,
			  android: 5
			},
			viewContainerRef: this.viewContainerRef, // ✅ Pass the instance from the component
			daysHidden: 6,
			daysReminder: 21,
		  });
		  
		  		
		}*/

	}

	private installNativeSwalChromeTracking(): void {
		this.nativeSwalChromeObserver = new MutationObserver(() => this.scheduleNativeSwalChromeMetrics());
		this.nativeSwalChromeObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
		window.addEventListener('resize', this.nativeSwalChromeResize, { passive: true });
		window.addEventListener('orientationchange', this.nativeSwalChromeResize, { passive: true });
		window.visualViewport?.addEventListener('resize', this.nativeSwalChromeResize, { passive: true });
		this.scheduleNativeSwalChromeMetrics(true);
	}

	private scheduleNativeSwalChromeMetrics(force = false): void {
		const hasHeader = this.nativeHeaderBodyClasses.some(className => document.body.classList.contains(className));
		const hasFooter = this.nativeFooterBodyClasses.some(className => document.body.classList.contains(className));
		const signature = `${hasHeader ? 'header' : ''}:${hasFooter ? 'footer' : ''}`;
		if (!force && signature === this.nativeSwalChromeSignature) return;
		this.nativeSwalChromeSignature = signature;
		if (this.nativeSwalChromeFrame) cancelAnimationFrame(this.nativeSwalChromeFrame);
		this.nativeSwalChromeFrame = requestAnimationFrame(() => {
			this.nativeSwalChromeFrame = 0;
			this.updateNativeSwalChromeMetrics(hasHeader, hasFooter);
		});
	}

	private updateNativeSwalChromeMetrics(hasHeader: boolean, hasFooter: boolean): void {
		const request = ++this.nativeSwalChromeMetricsRequest;
		if (!hasHeader && !hasFooter) {
			document.body.style.removeProperty('--native-swal-header-bottom');
			document.body.style.removeProperty('--native-swal-footer-clearance');
			return;
		}

		const applyMetrics = (metrics?: Awaited<ReturnType<typeof NativeLiquidGlass.getChromeMetrics>>): void => {
			if (request !== this.nativeSwalChromeMetricsRequest) return;
			const currentHasHeader = this.nativeHeaderBodyClasses.some(className => document.body.classList.contains(className));
			const currentHasFooter = this.nativeFooterBodyClasses.some(className => document.body.classList.contains(className));
			if (currentHasHeader !== hasHeader || currentHasFooter !== hasFooter) return;

			const webViewHeight = Number(metrics?.webViewHeight);
			const scale = metrics?.available && webViewHeight > 0 ? window.innerHeight / webViewHeight : 1;
			let headerBottom: number | null = hasHeader && metrics?.available && metrics.headerVisible
				&& Number.isFinite(metrics.headerBottom)
				? Number(metrics.headerBottom) * scale
				: null;
			let footerTop: number | null = hasFooter && metrics?.available && metrics.footerVisible
				&& Number.isFinite(metrics.footerTop)
				? Number(metrics.footerTop) * scale
				: null;

			if (hasHeader && headerBottom === null && !metrics?.available) {
				const headerSelectors = [
					['native-liquid-header', 'app-header-bar ion-header'],
					['native-eventos-header', '.eventos-native-replaced-header'],
					['native-hospedaje-header', '.hospedaje-native-replaced-header'],
					['native-dropship-header', '.dropship-native-replaced-header'],
				] as const;
				const bottoms = headerSelectors
					.filter(([className]) => document.body.classList.contains(className))
					.map(([, selector]) => document.querySelector<HTMLElement>(selector)?.getBoundingClientRect().bottom || 0)
					.filter(bottom => bottom > 0);
				headerBottom = bottoms.length ? Math.max(...bottoms) : null;
			}
			if (hasFooter && footerTop === null && !metrics?.available) {
				const domFooterTop = document.querySelector<HTMLElement>('app-footer-bar .footer-glass-island')?.getBoundingClientRect().top;
				footerTop = typeof domFooterTop === 'number' && Number.isFinite(domFooterTop) && domFooterTop > 0
					? domFooterTop
					: null;
			}

			if (headerBottom !== null) {
				document.body.style.setProperty('--native-swal-header-bottom', `${Math.max(0, headerBottom)}px`);
			} else {
				document.body.style.removeProperty('--native-swal-header-bottom');
			}
			if (footerTop !== null) {
				const footerClearance = Math.max(0, window.innerHeight - footerTop);
				document.body.style.setProperty('--native-swal-footer-clearance', `${footerClearance}px`);
			} else {
				document.body.style.removeProperty('--native-swal-footer-clearance');
			}
		};

		NativeLiquidGlass.getChromeMetrics().then(applyMetrics).catch(() => applyMetrics());
	}

	private bindNativePublicationOverlayLifecycle(): void {
		const overlayKinds = ['Modal', 'Popover', 'ActionSheet', 'Alert', 'Picker'];
		overlayKinds.forEach(kind => {
			document.addEventListener(`ion${kind}WillPresent`, this.nativePublicationOverlayWillPresent, true);
			document.addEventListener(`ion${kind}DidPresent`, this.nativePublicationOverlayDidPresent, true);
			document.addEventListener(`ion${kind}DidDismiss`, this.nativePublicationOverlayDidDismiss, true);
		});
	}

	private ionicOverlayTarget(event: Event): EventTarget | null {
		const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
		return path[0] || event.target;
	}

	private removeDisconnectedNativePublicationOverlays(): void {
		this.nativePublicationOverlays.forEach(overlay => {
			if (overlay instanceof Node && !overlay.isConnected) {
				this.nativePublicationOverlays.delete(overlay);
			}
		});
	}

	private suspendNativePublicationInformation(resetVisibility: boolean): void {
		if (Capacitor.getPlatform() !== 'ios') return;
		document.body.classList.add('native-publication-overlay-suspended');
		document.body.classList.remove('native-publication-info');
		NativeLiquidGlass.setPublicationInfoSuppressed({ suppressed: true }).catch(() => undefined);
		if (resetVisibility) {
			// A route transition invalidates the previous publication. A modal does
			// not, so modal suppression deliberately preserves desired visibility.
			NativeLiquidGlass.setRegion({ region: 'publication-info', visible: false }).catch(() => undefined);
			NativeLiquidGlass.setRegion({ region: 'publication-slide-nav', visible: false }).catch(() => undefined);
		}
		window.dispatchEvent(new CustomEvent('nativePublicationInfoVisibility', {
			detail: { visible: false }
		}));
	}

	private restoreNativePublicationInformationContext(): void {
		if (Capacitor.getPlatform() !== 'ios') return;
		if (!this.canRestoreNativePublicationInformation(this.router.url)) {
			// Keep the native publication surface suppressed on ordinary routed
			// pages. Cached feed components can still receive a late Angular
			// change-detection pass after NavigationEnd; leaving this guard active
			// prevents them from resurrecting their old native glass.
			this.suspendNativePublicationInformation(true);
			return;
		}
		document.body.classList.remove('native-publication-overlay-suspended');
		NativeLiquidGlass.setPublicationInfoSuppressed({ suppressed: false })
			.catch(() => undefined)
			.finally(() => {
				// Let Ionic finish removing its overlay and Angular expose the active
				// routed page before asking a publication component to restore itself.
				requestAnimationFrame(() => requestAnimationFrame(() => {
					window.dispatchEvent(new CustomEvent('nativePublicationContextRestored'));
				}));
			});
	}

	private normalizedRoutePath(url: string): string {
		return String(url || '').split('?')[0].split('#')[0].replace(/\/+$/, '') || '/';
	}

	private isProfileRoute(url: string): boolean {
		const path = this.normalizedRoutePath(url).toLowerCase();
		return /^\/(?:home\/)?profile(?:\/|$)/.test(path);
	}

	private canRestoreNativePublicationInformation(url: string): boolean {
		const path = this.normalizedRoutePath(url).toLowerCase();
		if (this.isProfileRoute(path)) return false;
		// Only routed publication surfaces may restore publication chrome.
		// Mycelium is a workspace route: its normal feed must never revive Home's
		// cached publication panel. When Mycelium opens its own full-screen media,
		// that component explicitly clears suppression and publishes its state.
		return path === '/home/my-feed'
			|| path === '/publication-feed'
			|| path.startsWith('/home/ecosystem-page')
			|| path === '/loader';
	}

	private synchronizeRouteNativeChrome(url: string): void {
		if (Capacitor.getPlatform() !== 'ios') return;
		const path = this.normalizedRoutePath(url).toLowerCase();
		if (path === '/mycelium' || path.startsWith('/mycelium/')) {
			// This is a hard ownership boundary. The Home media component may be
			// cached and emit one last update after navigation; retain suppression
			// so its info/toggle cannot appear over the Mycelium workspace.
			this.suspendNativePublicationInformation(true);
		}
		if (this.isProfileRoute(url)) {
			// The feed's full-screen mode is a shared service state. Clear it when
			// a profile is opened so the profile receives the normal native header.
			this.formService.mediaTemplate = false;
			this.formService.mostrar = true;
			this.suspendNativePublicationInformation(true);
		}
		document.dispatchEvent(new Event('laniakea:native-header-reconcile'));
		document.dispatchEvent(new Event(this.nativeChromeReconciliationEvent));
	}

	private scheduleNativeChromeReconciliation(): void {
		if (Capacitor.getPlatform() !== 'ios') return;
		this.nativeChromeReconciliationTimers.forEach(timer => clearTimeout(timer));
		// First frame synchronizes Angular owners; the later passes run after
		// Ionic's cached-page and UIKit transition completions.
		[0, 120, 360, 720].forEach(delay => {
			this.nativeChromeReconciliationTimers.push(setTimeout(() => {
				document.dispatchEvent(new Event(this.nativeChromeReconciliationEvent));
				NativeLiquidGlass.restoreRegions().catch(() => undefined);
			}, delay));
		});
	}

	private ionicMenuTarget(event: Event): EventTarget | null {
		const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
		const target = (path[0] || event.target) as HTMLElement | null;
		return target?.tagName?.toLowerCase() === 'ion-menu' ? target : null;
	}

	private isHubbleRoute(url: string): boolean {
		const normalized = String(url || '').toLowerCase();
		return normalized.includes('/wallet') || normalized.includes('hubble');
	}
	// Track background time for diagnostics only.  Re-routing through /loader on
	// foreground used to recreate the full launch experience after an iOS resume.
	// iOS can emit visibility transitions while WKWebView is still restoring its
	// first scene, which made that legacy "reboot" path look like a looping
	// startup loader.
	private bgSince: number | null = null;
	// Internal users below this threshold may screen record. User 150 and
	// above keep the existing privacy-screen protection enabled.
	private readonly screenRecordingAllowedBelowUserId = 150;

	private isScreenshotProtectionEnabled(): boolean {
		const profile = this.formService.profile;
		const userId = profile?.user_id ?? profile?.id;
		if (userId == null) {
			return true;
		}

		const numericUserId = Number(userId);
		return !Number.isFinite(numericUserId)
			|| numericUserId >= this.screenRecordingAllowedBelowUserId;
	}

	handleVisibilityChange() {
		if(this.isScreenshotProtectionEnabled()){
		if (document.hidden) {
			if(this.isScreenshotProtectionEnabled()){
			this.screenshotCombinationPressed = true;
			console.log(`Page is in background: `);
		}
			this.formService.changeMediaPeriodically=false;
			
		} else {
			console.log(`Page is in foreground: `);
			this.restoreNativeOverlays();

		  // Optionally, handle the case when the app comes back to the foreground
		  this.screenshotCombinationPressed = false;
		 // Came back to foreground
   

   

		
		}
	}


	if (document.hidden) {
		this.bgSince = Date.now();
		return;
	}

	if (this.bgSince !== null) {
		const backgroundDurationMs = Date.now() - this.bgSince;
		console.log(`[Lifecycle] Resumed after ${backgroundDurationMs}ms; preserving the current route.`);
	}
	this.bgSince = null;

	  }

	private restoreNativeOverlays(): void {
		if (Capacitor.getPlatform() !== 'ios') return;
		// Run once immediately and once after UIKit completes a picker/modal
		// dismissal transition. The plugin only re-fronts regions that were
		// already meant to be visible, so hidden route-specific UI stays hidden.
		NativeLiquidGlass.restoreRegions().catch(() => undefined);
		setTimeout(() => NativeLiquidGlass.restoreRegions().catch(() => undefined), 350);
	}
	@HostListener('document:keydown', ['$event'])
	handleKeyDownEvent(event: KeyboardEvent) {
		if(this.isScreenshotProtectionEnabled()){
	  // Check if the keys pressed are Command (Mac) or Ctrl (Windows/Linux) and Shift
	  if ((event.metaKey || event.ctrlKey) && event.shiftKey) {
	
		if(this.isScreenshotProtectionEnabled()){
		//
		// If the combination of keys matches, prevent default behavior
		event.preventDefault();
		// Set the flag to indicate that the screenshot combination is pressed
		this.screenshotCombinationPressed = true;
		// Do something to handle the screenshot attempt
		console.log('Screenshot attempt detected!');
		Swal.fire({
			title: 'Screenshots are not allowed!',
			text: `Because Laniakea contains exclusive or paid content, screenshots and screen recordings are not allowed.`,
			icon: 'warning',
			//timer: 6900, // Show the alert for 3.9 seconds
			//timerProgressBar: true,
			toast: true,
			position: 'top-end',
			showCancelButton: false,
			confirmButtonText: 'ok',
			cancelButtonText: 'No',
			color: '#ffffff',
			background: '#010f4e',
		  });
		}
	
	  }else if (event.key === 'VolumeUp'||event.key === 'VolumeDown') {
		if(this.isScreenshotProtectionEnabled()){
		// Handle volume up button press
		console.log('Volume up button pressed on iOS');
		this.screenshotCombinationPressed = true;
		// Do something to handle the screenshot attempt
		console.log('Screenshot attempt detected!');
		Swal.fire({
			title: 'Screenshots are not allowed!',
			text: `Because Laniakea contains exclusive or paid content, screenshots and screen recordings are not allowed.`,
			icon: 'warning',
			//timer: 6900, // Show the alert for 3.9 seconds
			//timerProgressBar: true,
			toast: true,
			position: 'top-end',
			showCancelButton: false,
			confirmButtonText: 'ok',
			cancelButtonText: 'No',
			color: '#ffffff',
			background: '#010f4e',
		  });
		}
	  }
	}
	}
	initVolumeKeyDetection() {
		if(this.isScreenshotProtectionEnabled()){
		// Detect volume button presses
		window.addEventListener('keydown', this.detectVolumeKeys.bind(this));
		}
	  }
	
	  private detectVolumeKeys(event: KeyboardEvent) {
		if(this.isScreenshotProtectionEnabled()){
		this.ngZone.run(() => {
		  if (event.key === 'VolumeDown') {
			if(this.isScreenshotProtectionEnabled()){
			this.screenshotCombinationPressed = true;
			// Do something to handle the screenshot attempt
			console.log('Screenshot attempt detected!');
			Swal.fire({
				title: 'Screenshots are not allowed!',
				text: `Because Laniakea contains exclusive or paid content, screenshots and screen recordings are not allowed.`,
				icon: 'warning',
				//timer: 6900, // Show the alert for 3.9 seconds
				//timerProgressBar: true,
				toast: true,
				position: 'top-end',
				showCancelButton: false,
				confirmButtonText: 'ok',
				cancelButtonText: 'No',
				color: '#ffffff',
				background: '#010f4e',
			  });
			console.log('Volume Down button pressed');
			}
			// Add your logic here
		  } else if (event.key === 'VolumeUp') {
			if(this.isScreenshotProtectionEnabled()){
			this.screenshotCombinationPressed = true;
			// Do something to handle the screenshot attempt
			console.log('Screenshot attempt detected!');
			Swal.fire({
				title: 'Screenshots are not allowed!',
				text: `Because Laniakea contains exclusive or paid content, screenshots and screen recordings are not allowed.`,
				icon: 'warning',
				//timer: 6900, // Show the alert for 3.9 seconds
				//timerProgressBar: true,
				toast: true,
				position: 'top-end',
				showCancelButton: false,
				confirmButtonText: 'ok',
				cancelButtonText: 'No',
				color: '#ffffff',
				background: '#010f4e',
			  });
			console.log('Volume Down button pressed');
			// Add your logic here
		  }
		}
		});
	}
	  }
	@HostListener('document:keyup', ['$event'])
	handleKeyUpEvent(event: KeyboardEvent) {
		if(this.isScreenshotProtectionEnabled()){
	  // Check if the keys released are Command (Mac) or Ctrl (Windows/Linux) and Shift
	  if ((event.metaKey || event.ctrlKey) || event.shiftKey) {
		if(this.isScreenshotProtectionEnabled()){
		
	
		// Reset the flag to indicate that the screenshot combination is released
		this.screenshotCombinationPressed = false;
		}
		this.formService.changeMediaPeriodically=false;
		console.log('Screenshot disattempt detected!');
	  } if (event.key === 'VolumeUp'||event.key === 'VolumeDown') {
		if(this.isScreenshotProtectionEnabled()){
		// Handle volume down button press
		console.log('Volume  button pressed on mobile');
		this.screenshotCombinationPressed = false;
		}
	  }
	}
	}
	@HostListener('window:keydown', ['$event'])
	handleMobileKeyDownEvent(event: KeyboardEvent) {
		if(this.isScreenshotProtectionEnabled()){
	  // Check if the key pressed is the volume up button (iOS)
	  if (event.key === 'VolumeUp'||event.key === 'VolumeDown') {
		// Handle volume up button press
		console.log('Volume up/down button pressed');
		if(this.isScreenshotProtectionEnabled()){
		this.screenshotCombinationPressed = true;
		}
		// Do something to handle the screenshot attempt
		console.log('Screenshot attempt detected!');
		Swal.fire({
			title: 'Screenshots are not allowed!',
			text: `Because Laniakea contains exclusive or paid content, screenshots and screen recordings are not allowed.`,
			icon: 'warning',
			//timer: 6900, // Show the alert for 3.9 seconds
			//timerProgressBar: true,
			toast: true,
			position: 'top-end',
			showCancelButton: false,
			confirmButtonText: 'ok',
			cancelButtonText: 'No',
			color: '#ffffff',
			background: '#010f4e',
		  });
	  }
	}
	}
	
	@HostListener('window:keyup', ['$event'])
	handleMobileKeyUpEvent(event: KeyboardEvent) {
		if(this.isScreenshotProtectionEnabled()){
	  // Check if the key pressed is the volume down button (Android)
	  if (event.key === 'VolumeUp'||event.key === 'VolumeDown') {
		// Handle volume down button press
		if(this.isScreenshotProtectionEnabled()){
		this.screenshotCombinationPressed = false;
		}
		console.log('Volume up/down button released on mobile');
	  }
	}
	}
	

	
	async getNetwork() {
		if (Capacitor.getPlatform() !== 'android') {
			const getId = await Device.getId();
			  
				console.log('device_id',getId);
				this.formService.deviceid = String(getId.uuid);
		
				const getInfo = await Device.getInfo();
			  
				console.log('device',getInfo);
				this.formService.device=getInfo;
		
				const getLanguageCode = await Device.getLanguageCode();
			  
				console.log('language', getLanguageCode.value);
			this.formService.language=getLanguageCode.value;
		} else {
			// Avoid "Device" plugin on Android - it is not implemented in current build
			this.formService.deviceid = this.formService.deviceid || 'android-' + Date.now();
			this.formService.device = this.formService.device || { platform: 'android' };
			this.formService.language = this.formService.language || (navigator.language || 'es').split('-')[0];
		}

		// Capacitor's web Network shim can report a false offline state in a
		// browser tab. On web, the browser is the source of truth; native builds
		// continue to use Capacitor's real network monitor.
		if (Capacitor.getPlatform() === 'web') {
			const updateBrowserNetwork = () => {
				const status = { connected: navigator.onLine, connectionType: navigator.onLine ? 'unknown' : 'none' };
				this.formService.network = status;
				this.zone.run(() => {
					this.isOffline = !status.connected;
					if (status.connected) this.recoverPendingUniversalNavigation();
				});
			};
			updateBrowserNetwork();
			window.addEventListener('online', updateBrowserNetwork);
			window.addEventListener('offline', updateBrowserNetwork);
		} else {
			const info = await Network.getStatus();
			console.log('network', info);
			this.formService.network = info;
			this.isOffline = !info.connected;
			Network.addListener('networkStatusChange', (status) => {
				console.log('Network status changed:', status);
				this.formService.network = status;
				this.zone.run(() => {
					this.isOffline = !status.connected;
					if (status.connected) this.recoverPendingUniversalNavigation();
				});
			});
		}
		this.getClientIpAddress();
		this.send_internet_pro_data();
	  }
	  send_internet_pro_data(){
		 
		this.request.createRequestPost('GetAuthUser', {get_user:true })
  .then((final_data) => {
    console.log('final_data',final_data);
	if (final_data && typeof final_data === 'string') {
        try {
          final_data = JSON.parse(final_data);
          console.log('getRecordByToken ios:',final_data);
        } catch (error) {
          console.error("Error parsing data:", error);
        }
        }
    this.request.createRequestPost('ProtoInternetData', {user_id:final_data?.user?.id, IPAddress: this.formService.IPAddress, deviceid:this.formService.deviceid, language: this.formService.language, device: this.formService.device, network:this.formService.network })
      .then((final_data) => {
		
        /*
         Swal2.fire({
          title: 'INTERNET verificado exitosamente.',
          text: El token ha sido validado exitosamente: ${this.celular}. ,
          icon: 'success',
          confirmButtonText: 'Accept',
          background: '#010f4e',
        });*/
      })
  })
  .catch((error) => {
    console.error('Error in GetAuthUser:', error);
    // Make ProtoInternetData request here even if there is an error in GetAuthUser
    this.request.createRequestPost('ProtoInternetData', {
      user_id: null, // Set user_id to null or a default value
      IPAddress: this.formService.IPAddress,
      deviceid:this.formService.deviceid,
      language: this.formService.language,
      device: this.formService.device,
      network:this.formService.network
    })
      .then((final_data) => {
      
      })
  });
	  }
	  async getClientIpAddress(): Promise<string> {
		try {
		  const ipAddress = await this.http.get('https://api.ipify.org/?format=json').toPromise();
		  //console.log('ipAddress',ipAddress['ip']);
		  this.formService.IPAddress=ipAddress['ip'];
		  return ipAddress['ip'];
		} catch (error) {
		  console.error('Error fetching IP address:', error);
		  return null;
		}
	  }
	  async open_content_preferences_modal(){
		const modal = await this.modalctrl.create({
			component: ContentPreferencesComponent,
			canDismiss: true, // canDismiss enables swipe-to-close (patch forces on ALL ModalController creates)
			componentProps: {
		
			  //valueSelect: 'MENU',
			  // Pass the publication ID or other necessary data to the component
			}
		  });
		  await modal.present();
	  }
	 delayed_shit(){
		if (Capacitor.getPlatform() === 'web') {
	// Function to handle the screen recording started event
	const handleScreenRecordingStarted = () => {
		console.log('Screen recording started');
		this.screenshotCombinationPressed=true;
		// Add your logic here
	  };
	// Add the event listener when your component initializes or as needed
	const screenRecordingStartedListener = PrivacyScreen.addListener('screenRecordingStarted', handleScreenRecordingStarted);
	}
	this.initVolumeKeyDetection();
	
	// Always call getNetwork - it now has internal condition to avoid Device plugin on Android
	this.getNetwork();
		this.enforceLatestVersion();
		if (Capacitor.getPlatform() === 'ios') {
		this.subscribedToProduct();
		}
	 }

	private installNavigationQualityTracking(): void {
		this.router.events.subscribe((event: RouterEvent) => {
			if (event instanceof NavigationStart) {
				this.appQuality.navigationStarted(event.id, event.url);
				return;
			}
			if (event instanceof NavigationEnd) {
				this.appQuality.navigationCompleted(event.id, event.urlAfterRedirects, true);
				this.navigationState.recordSuccessfulRoute(event.urlAfterRedirects);
				const settledPath = event.urlAfterRedirects.split(/[?#]/, 1)[0];
				if (settledPath !== '/' && settledPath !== '/loader') {
					// NavigationEnd can fire before the destination is painted. Two frames
					// measure the first usable screen instead of only Angular routing time.
					requestAnimationFrame(() => requestAnimationFrame(() => {
						this.appQuality.markAppInteractive(event.urlAfterRedirects);
					}));
				}
				return;
			}
			if (event instanceof NavigationCancel) {
				this.appQuality.navigationCompleted(event.id, event.url, false, event.reason);
				return;
			}
			if (event instanceof NavigationError) {
				this.appQuality.navigationCompleted(event.id, event.url, false, event.error);
			}
		});
	}

	initializeApp() {
		this.redirectLightbulbWebRoot();
			let promises: Array<Promise<any>> = [];
	this.platform.ready().then(() => {
		  console.log('Platform ready');
		  this.navigationState.markPlatformReady();
		  this.initializeBackGroundMode();

		  // Enable Left-to-Right swipe to close on ALL modals globally
		  // (works even on heavily customized modals like .detailsInModal)
		  setupGlobalLeftToRightModalDismiss(this.gestureCtrl);

		  //promises.push(this.notificationsService.initialize());
		  Promise.all(promises).then(() => {
			console.log('Promises resolved');
	
		
		  }).catch((error) => {
			console.error('Promise error:', error);
		  });
	
		}).catch((error) => {
		  // Never leave a queued Universal Link waiting forever if a plugin's
		  // platform-ready promise rejects during a degraded startup.
		  this.navigationState.markPlatformReady();
		  console.error('Platform error:', error);
		});
		
		//	this.titleService.setTitle('Comunicación');
			//const interval = setInterval(() => {
				
	//		}, 3000);

		

		
		//this.foregroundService.start('Laniakea esta activo', 'Servicio Laniakea Activo en tu dispositivo', 'drawable/fsicon');
	

		
		if (Capacitor.getPlatform() !== 'web') {
		this.initializeUniversalNavigation();
	}

	// Web fallback for shared URLs when the native app is not installed.
	const initialWebLink = this.getUniversalLinkPath(window.location.href);
	if (Capacitor.getPlatform() === 'web' && initialWebLink && this.requiresWebUniversalResolution(initialWebLink)) {
		this.queueUniversalNavigation(initialWebLink, 'web-initial-url');
	}

	//if (Capacitor.getPlatform() !== 'android') {

	//}

		this.scheduleAfterFirstRender(() => { void this.playAudio(); }, 600);


			setTimeout(() => {
			  // Gradually lower the volume over a duration of 2 seconds
			this.delayed_shit();
			}, 21000);

		this.scheduleAfterFirstRender(() => this.loadProfileAfterRender(), 400);
  }

	private redirectLightbulbWebRoot(): void {
		if (Capacitor.getPlatform() !== 'web') return;

		const hostname = window.location.hostname.toLowerCase();
		const isLightbulbDomain = hostname === 'lightbulb.mx';
		const isDomainRoot = window.location.pathname === '/' || window.location.pathname === '';
		if (!isLightbulbDomain || !isDomainRoot) return;

		this.router.navigateByUrl('/home/ecosystem-page/wallet', { replaceUrl: true });
	}

	private initializeUniversalNavigation(): void {
		if (this.universalNavigationInitialized) return;
		this.universalNavigationInitialized = true;

		App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
			this.zone.run(() => this.queueUniversalNavigation(event.url, 'universal-link'));
		});

		// Capacitor can emit appUrlOpen before Angular registers its listener on
		// a cold launch. Recover the original Universal Link explicitly.
		App.getLaunchUrl().then(result => {
			if (Capacitor.getPlatform() === 'ios') {
				void NativeSpotlight.takePendingURL().then(({ url }) => {
					if (url && url !== result?.url) this.zone.run(() => this.queueUniversalNavigation(url, 'cold-launch-url'));
				}).catch(() => undefined);
			}
			if (result?.url) {
				this.zone.run(() => this.queueUniversalNavigation(result.url, 'cold-launch-url'));
				return;
			}
			this.zone.run(() => this.recoverPendingUniversalNavigation());
		}).catch(error => {
			console.warn('Could not recover launch URL:', error);
			this.zone.run(() => this.recoverPendingUniversalNavigation());
		});

		PushNotifications.addListener('pushNotificationActionPerformed', (action: ActionPerformed) => {
			void this.applyLiveActivityUpdate(action?.notification?.data);
			this.zone.run(() => this.handlePushNavigation(action));
		});
		PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
			void this.applyLiveActivityUpdate(notification?.data);
		});
	}

	private async applyLiveActivityUpdate(data: any): Promise<void> {
		// Notification data carries live_activity as JSON: id, kind, title,
		// status, detail, progress (0...1), destination, or { id, action: 'end' }.
		if (Capacitor.getPlatform() !== 'ios' || !data?.live_activity) return;
		try {
			const update = typeof data.live_activity === 'string'
				? JSON.parse(data.live_activity) : data.live_activity;
			const id = String(update?.id || '');
			if (!id) return;
			if (update.action === 'end') {
				await NativeLiveActivities.end({ id });
				return;
			}
			if (update.kind !== 'delivery' && update.kind !== 'event') return;
			await NativeLiveActivities.upsert({
				id,
				kind: update.kind,
				title: String(update.title || ''),
				status: String(update.status || ''),
				detail: String(update.detail || ''),
				progress: Number(update.progress) || 0,
				destination: String(update.destination || ''),
			});
		} catch (error) {
			console.warn('Could not update Live Activity:', error);
		}
	}

	private handlePushNavigation(action: ActionPerformed): void {
		const data = this.parsePushData(action?.notification?.data);
		if (data.meeting_id) {
			if (action?.actionId === 'dismiss') return;
			if (action?.actionId === 'LANIAKEA_DECLINE_CALL') {
				void this.request.createRequestPost('iosCall', { action: 'reject', meeting_id: String(data.meeting_id) }).catch(console.warn);
				return;
			}
			void this.openIncomingCallNotification(String(data.meeting_id), action?.actionId === 'LANIAKEA_ANSWER_CALL');
			return;
		}
		const universalLink = this.getPushUniversalLink(data);
		const slug = this.getUniversalLinkPath(universalLink);
		if (slug) {
			this.queueUniversalNavigation(slug, 'push');
			return;
		}

		this.navCtrl.navigateForward('/notifications-page');
	}

	private readonly openingCallNotifications = new Set<string>();
	private async openIncomingCallNotification(meetingId: string, answer = false): Promise<boolean> {
		if (!meetingId || meetingId.length > 191) return false;
		if (this.openingCallNotifications.has(meetingId)) return true;
		this.openingCallNotifications.add(meetingId);
		try {
			if (Capacitor.getPlatform() === 'ios' && Capacitor.isPluginAvailable('NativeCalls')) {
				await NativeCalls.openIncoming({ meeting_id: meetingId, answer });
				return true;
			}
			// Android/web fallback opens the existing meeting component directly.
			// Check the authenticated call record before joining a stale notification.
			const raw = await this.request.createRequestPost('iosCall', { action: 'status', meeting_id: meetingId });
			const state = typeof raw === 'string' ? JSON.parse(raw) : raw;
			if (!state?.is_recipient || state.status !== 'ringing') throw new Error('Call has ended');
			await this.navCtrl.navigateRoot(`/chime-contact?incoming_call=true&meeting_id=${encodeURIComponent(meetingId)}`, { replaceUrl: true });
			return true;
		} catch (error) {
			console.warn('Could not open incoming call:', error);
			await Swal.fire({ title: 'Llamada no disponible', text: 'La llamada puede haber finalizado. Intenta llamar de nuevo.', icon: 'info' });
			return true; // Consume the intent; never retry it as notification navigation.
		} finally {
			this.openingCallNotifications.delete(meetingId);
		}
	}

	private queueUniversalNavigation(rawUrl: string, source: ExternalNavigationSource): void {
		const target = this.getUniversalLinkPath(rawUrl);
		if (!target) return;
		void this.navigationState.enqueueExternalNavigation(
			target,
			source,
			path => this.zone.run(() => this.handleUniversalLink(path)),
		).then(success => {
			if (!success) console.warn('Universal navigation did not reach its destination:', target);
		});
	}

	private recoverPendingUniversalNavigation(): void {
		const pending = this.navigationState.recoverPendingExternalNavigation();
		if (pending) this.queueUniversalNavigation(pending.target, pending.source);
	}

	private requiresWebUniversalResolution(path: string): boolean {
		return /^\/(?:p\/\d+|api\/share-preview\/|loader\?meeting)/.test(path)
			|| this.extractQueryPublicationId(path) !== null
			|| !!this.extractAppleTvPairingCode(path);
	}

	private parsePushData(rawData: any): any {
		let data = rawData;
		if (typeof data === 'string') {
			try { data = JSON.parse(data); } catch { data = {}; }
		}
		if (!data || typeof data !== 'object') return {};
		return data.data && typeof data.data === 'object' ? { ...data, ...data.data } : data;
	}

	private getPushUniversalLink(data: any): string {
		if (data?.meeting_id) return `https://laniakea.tv/calls/incoming?meeting_id=${encodeURIComponent(String(data.meeting_id))}`;
		const explicitLink = data?.universal_link || data?.link || data?.deep_link;
		if (typeof explicitLink === 'string' && explicitLink.trim()) return explicitLink.trim();

		const conversationId = String(data?.conversation_id || data?.chat_id || '').trim();
		if (/^[A-Za-z0-9-]{1,128}$/.test(conversationId)) {
			return `https://laniakea.tv/home/chat-page/${encodeURIComponent(conversationId)}`;
		}

		const publicationId = Number(data?.publication_id || data?.post || data?.post_id || 0);
		if (Number.isSafeInteger(publicationId) && publicationId > 0) {
			return `https://laniakea.tv/p/${publicationId}`;
		}

		return 'https://laniakea.tv/notifications-page';
	}

	private getUniversalLinkPath(rawUrl: string): string | null {
		try {
			const parsed = new URL(rawUrl);
			const allowedHosts = new Set([
				'laniakea.tv',
				'www.laniakea.tv',
				'supercluster.laniakea.tv',
				'supercluster-api.laniakea.tv',
				'supercumulo.laniakea.tv',
				'laniakea.laniakea.tv',
				'lightbulb.mx',
			]);
			if ((parsed.protocol === 'https:' || parsed.protocol === 'http:') && !allowedHosts.has(parsed.hostname.toLowerCase())) {
				return null;
			}
			return `${parsed.pathname || '/'}${parsed.search}${parsed.hash}`;
		} catch {
			return rawUrl.startsWith('/') ? rawUrl : null;
		}
	}

	private startProfileWarmup(): Promise<any> {
		if (!this.startupProfileWarmup) {
			this.startupProfileWarmup = this.profileService.getProfileInfo()
				.then((result) => typeof result === 'string' ? JSON.parse(result) : result);
		}
		return this.startupProfileWarmup;
	}

	private loadProfileAfterRender(): void {
		this.startProfileWarmup()
    .then((profile) => {
		this.pr = profile;
        console.log("profile", this.pr);
        this.formService.profile = this.pr;
        void this.callSignaling.start('profile loaded').catch(console.warn);

		if (Capacitor.getPlatform() === 'ios') {
            if (this.isScreenshotProtectionEnabled()) {
                PrivacyScreen.enable()
                    .then(() => console.log('PrivacyScreen.enable'))
                    .catch((error) => console.error('Error enabling PrivacyScreen:', error));
            } else {
                PrivacyScreen.disable()
                    .then(() => console.log('PrivacyScreen.disable'))
                    .catch((error) => console.error('Error disabling PrivacyScreen:', error));
            }
        }

        if (!this.pr.content_preferences) { 
           // setTimeout(() => {
             //   this.open_content_preferences_modal();
            //}, 160000);
        }
    })
    .catch((error) => {
        console.error('Error fetching profile info:', error);
        
        if (Capacitor.getPlatform() === 'ios') {
            if (this.isScreenshotProtectionEnabled()) {
                PrivacyScreen.enable()
                    .then(() => console.log('PrivacyScreen.enable'))
                    .catch((error) => console.error('Error enabling PrivacyScreen:', error));
            } else {
                PrivacyScreen.disable()
                    .then(() => console.log('PrivacyScreen.disable'))
                    .catch((error) => console.error('Error disabling PrivacyScreen:', error));
            }
        }
    });
	}
	  async SplashScreen(){
	
		  // Show the splash for two seconds and then automatically hide it:
// Hide native splash as early as possible to minimize custom loader visibility
		try {
			await SplashScreen.hide();
		} catch (e) {
			console.warn('SplashScreen.hide failed', e);
		}
		


  
  

	  }
	 
	
	  async handleUniversalLink(slug: string): Promise<boolean> {
		console.log('handleUniversalLink called');
		if (/^\/calls\/incoming(?:[?#]|$)/.test(slug)) {
			const meeting = new URL(slug, 'https://laniakea.tv').searchParams.get('meeting_id') || '';
			return this.openIncomingCallNotification(meeting);
		}
		if (this.router.url === this.universalAngularPath(slug)) return true;
		if (await this.handleAppleTvPairingLink(slug)) {
			return true;
		}

		// OAuth authorization responses also contain the standard `code`
		// parameter. They are completed by the provider callback/backend and the
		// login page's existing token validation flow; they must never be routed
		// into a QR screen or treated as a normal in-app destination.
		if (this.isOAuthCallbackLink(slug)) {
			await this.finishOAuthCallback(slug);
			return true;
		}

		// Preview endpoints are crawler-facing URLs.  When a user taps one on an
		// iPhone, resolve it back to the real in-app destination instead of
		// navigating to the preview HTML (or the old, nonexistent feed route).
		const previewPublicationMatch = slug.match(/^\/api\/share-preview\/publication\/(\d+)(?:[/?#]|$)/);
		if (previewPublicationMatch) {
			return this.getUniversalLinkPublications(Number(previewPublicationMatch[1]));
		}
		const previewFeexMatch = slug.match(/^\/api\/share-preview\/feex\/(\d+)(?:[/?#]|$)/);
		if (previewFeexMatch) {
			const parsed = new URL(slug, 'https://supercluster-api.laniakea.tv');
			const productId = previewFeexMatch[1];
			const productSlug = parsed.searchParams.get('slug') || 'producto';
			return this.navCtrl.navigateRoot(
				`/feex-wholesale/${encodeURIComponent(productSlug)}?product_id=${encodeURIComponent(productId)}`
			);
		}

		if (/^\/feex-wholesale(?:[/?#]|$)/.test(slug)) {
			const target = this.universalLinkPathAndQuery(slug, '/feex-wholesale');
			return this.navCtrl.navigateRoot(target);
		}
		if (/^\/feex(?:[/?#]|$)/.test(slug)) {
			const target = this.universalLinkPathAndQuery(slug, '/feex');
			return this.navCtrl.navigateRoot(target);
		}
		if (/^\/home\/ecosystem-page\/wallet(?:[/?#]|$)/.test(slug)) {
			return this.navCtrl.navigateRoot('/home/ecosystem-page/wallet');
		}

		const publicationMatch = slug.match(/^\/p\/(\d+)(?:[/?#]|$)/);
		const queryPublicationId = this.extractQueryPublicationId(slug);
		if (publicationMatch) {
			return this.getUniversalLinkPublications(Number(publicationMatch[1]));
		} else if (queryPublicationId !== null) {
			return this.getUniversalLinkPublications(queryPublicationId);
		} else if (slug.includes('/loader?meeting')) {
			const meetingID = this.extractMeetingIDFromSlug(slug);
			console.log('Meeting ID:', meetingID);
			if (meetingID !== null) {
				return this.navigateToMeetingPage(meetingID);
			}
			return false;
		} else if (slug.includes('/home/ecosystem-page')){
		const publicationId = this.extractPublicationIdFromSlug(slug);
		console.log('Publication ID:', publicationId);
		if (publicationId !== null) {
			return this.getUniversalLinkPublications(publicationId);
		}
		// `/home/ecosystem-page` is also a valid destination without a post ID.
		return this.navCtrl.navigateRoot(this.universalAngularPath(slug));
		}

		// AASA accepts every Angular path. Preserve the complete route instead
		// of maintaining a manual list that goes stale when routes are added.
		return this.navCtrl.navigateRoot(this.universalAngularPath(slug));
	  }

		private universalAngularPath(slug: string): string {
			try {
				const parsed = new URL(slug.startsWith('http')
					? slug
					: `https://laniakea.tv${slug.startsWith('/') ? '' : '/'}${slug}`);
				return `${parsed.pathname || '/'}${parsed.search}${parsed.hash}`;
			} catch {
				return slug.startsWith('/') && !slug.startsWith('//') ? slug : '/';
			}
		}

		private extractQueryPublicationId(slug: string): number | null {
			try {
				const parsed = new URL(slug.startsWith('http') ? slug : `https://laniakea.tv${slug.startsWith('/') ? '' : '/'}${slug}`);
				const raw = parsed.searchParams.get('post') || parsed.searchParams.get('post_id') || parsed.searchParams.get('p');
				if (!raw || !/^\d+$/.test(raw)) return null;
				const id = Number(raw);
				return Number.isSafeInteger(id) && id > 0 ? id : null;
			} catch {
				return null;
			}
		}

		private universalLinkPathAndQuery(slug: string, fallback: string): string {
			try {
				const normalized = slug.startsWith('http')
					? slug
					: `https://supercluster.laniakea.tv${slug.startsWith('/') ? '' : '/'}${slug}`;
				const parsed = new URL(normalized);
				const query = parsed.search || '';
				const pathname = parsed.pathname.replace(/\/+$/, '') || '/';
				const path = pathname === fallback || pathname.startsWith(`${fallback}/`)
					? pathname
					: fallback;
				return `${path}${query}`;
			} catch {
				return fallback;
			}
		}

		private async handleAppleTvPairingLink(url: string): Promise<boolean> {
			const code = this.extractAppleTvPairingCode(url);

			if (!code) {
				return false;
			}

			return this.router.navigate(['/apple-tv/sync'], {
				queryParams: { scanMode: 'apple-tv' },
				replaceUrl: true
			});
		}

		private extractAppleTvPairingCode(url: string): string | null {
			try {
				const parsedUrl = new URL(url);
				return parsedUrl.searchParams.get('apple_tv_pairing_code') ||
					parsedUrl.searchParams.get('apple_tv_code');
			} catch (error) {
				const queryString = url.split('?')[1];

				if (!queryString) {
					return null;
				}

				const queryParams = new URLSearchParams(queryString);

				return queryParams.get('apple_tv_pairing_code') ||
					queryParams.get('apple_tv_code');
			}
		}

		private isOAuthCallbackLink(url: string): boolean {
			try {
				const parsedUrl = new URL(url);
				// Apple TV pairing is classified exclusively by its own explicit
				// parameter, never by OAuth's generic authorization code.
				if (parsedUrl.searchParams.has('apple_tv_pairing_code') || parsedUrl.searchParams.has('apple_tv_code')) {
					return false;
				}
				return parsedUrl.searchParams.has('state') && (
					parsedUrl.searchParams.has('code') || parsedUrl.searchParams.has('error')
				);
			} catch {
				return false;
			}
		}

		private async finishOAuthCallback(url: string): Promise<void> {
			// A provider can emit the callback more than once while the native
			// browser is handing control back to the app. Do not show duplicate
			// feedback or race Browser.close().
			if (Date.now() - this.oauthCallbackHandledAt < 5000) return;
			this.oauthCallbackHandledAt = Date.now();

			// The callback page is not part of the app's navigation surface. Close
			// the Capacitor Browser as soon as the deep link arrives, instead of
			// waiting for the login polling request or requiring a manual close.
			try {
				await Browser.close();
			} catch (error) {
				// Browser.close() can reject when the callback came from a cold launch
				// or the user already dismissed the browser. The login flow can still
				// complete through its token polling in either case.
				console.debug('OAuth browser was already closed:', error);
			}

			const callbackFailed = this.oauthCallbackHasError(url);
			void Swal.fire({
				title: callbackFailed ? 'No se pudo completar el acceso' : 'Autorización recibida',
				html: callbackFailed
					? 'El proveedor no pudo autorizar la cuenta. Puedes intentarlo nuevamente.'
					: '<strong>Token recibido correctamente</strong><br><small>Finalizando el inicio de sesión…</small>',
				icon: callbackFailed ? 'error' : 'success',
				background: '#010f4e',
				color: '#ffffff',
				showConfirmButton: false,
				timer: callbackFailed ? 3000 : 1400,
				timerProgressBar: true,
				position: 'top-end',
				toast: true,
			});
		}

		private oauthCallbackHasError(url: string): boolean {
			try {
				return new URL(url).searchParams.has('error');
			} catch {
				const query = url.split('?')[1] || '';
				return new URLSearchParams(query).has('error');
			}
		}

		extractMeetingIDFromSlug(slug: string): string | null {

			const queryParams = new URLSearchParams(slug.split('?')[1]);
			const meetingIDStr = queryParams.get('meeting');

		
			return meetingIDStr;
		  }
		  
		  // ...
		  
		  navigateToMeetingPage(meetingID: string): Promise<boolean> {
			// Build the URL
			const url = `https://supercumulo.laniakea.tv/loader?meeting=${meetingID}`;
		  
		
		  
			// Optionally, you can also open the URL in a browser
			return this.openBrowser(url);
		  }
		  
		  async openBrowser(url: string): Promise<boolean> {
			//await Browser.open({ url });
			return window.open(url, '_blank') !== null; // Open the URL in a new tab or window
		  }
		  extractPublicationIdFromSlug(slug: string): number | null {
			const queryParams = new URLSearchParams(slug.split('?')[1]);
			const slugParts = slug.split('?')[0].split('/').filter(Boolean);
			const publicationIdStr = queryParams.get('p') || slugParts[slugParts.length - 1];
		  
			if (!publicationIdStr) {
			  console.error('Publication ID not found in URL:', slug);
			  return null;
			}
		  
			const publicationId = Number(publicationIdStr);
			if (isNaN(publicationId)) {
			  console.error('Invalid publication ID:', publicationIdStr);
			  return null;
			}
		  
			return publicationId;
		  }
		  extractProfileIdFromSlug(slug: string): number | null {
			// Extract the 'p' query parameter from the URL
			const slugParts = slug.split('/');
			const publicationIdStr = slugParts[slugParts.length -1];
		  
			if (!publicationIdStr) {
			  console.error('Publication ID not found in URL:', slug);
			  return null;
			}
		  
			const publicationId = Number(publicationIdStr);
			if (isNaN(publicationId)) {
			  console.error('Invalid publication ID:', publicationIdStr);
			  return null;
			}
		  
			return publicationId;
		  } 
	
	  
	
	  async getUniversalLinkPublications(publicationId: number): Promise<boolean> {
		if (!Number.isSafeInteger(publicationId) || publicationId <= 0) return false;

		// Let the routed publication surface own loading and rendering. Mutating
		// FormService here races with the ecosystem page during a native cold
		// launch: its initialization can replace the publications populated by
		// this root component before the media template is mounted.
		return this.navCtrl.navigateRoot(`/home/ecosystem-page/${publicationId}`);
	  }
	  async openComponentVideoTry(fetchedPublications) {
		const modal = await this.modalctrl.create({
		  component: LkfilmViewBySlidesComponent,
		  canDismiss: true, // (forced globally for swipe close on all modals)
		  componentProps: {
			publications: fetchedPublications,
			//valueSelect: 'MENU',
			// Pass the publication ID or other necessary data to the component
		  }
		});
		await modal.present();
	  }
	  openComponentVideo(fetchedPublications){
		
		this.formService.mostrar = false;
	 this.formService.publications=fetchedPublications;
	  this.formService.valueSelect= 'MENU';
	  this.formService.mediaTemplate=true;
	
	  }
	

	initializeBackGroundMode() {
		const options = {
			id: 1,
			title: 'Laniakea',
			text: 'Active Service',
			hidden: false,
			silent: true,
			sticky: true,
			resume: true,
			foreground: true,
		};
		//this.backgroundMode.setDefaults(options);
		//this.backgroundMode.excludeFromTaskList();
		//this.backgroundMode.overrideBackButton();
		//this.backgroundMode.enable();
		//this.backgroundMode.on('activate').subscribe(() => {
			//this.backgroundMode.disableWebViewOptimizations();
			//this.backgroundMode.disableBatteryOptimizations();
	//	});
		//this.statusBar.overlaysWebView(false);
		//this.statusBar.backgroundColorByHexString("#222428");
		//this.statusBar.styleLightContent();
	}
	
	
	async subscribedToProduct(): Promise<void> {

		this.store.register({
		  id: this.productId2,
		  alias: this.productId2,
		  type: this.store.PAID_SUBSCRIPTION, // Change the type to PAID_SUBSCRIPTION
		});
		
		// Fetch the product information
		const product = await this.store.get(this.productId2);
		
		// Updated
		this.store.when(this.productId2).updated((product: IAPProduct) => {
		  console.log('Updated: ' + JSON.stringify(product));
		  if (product.owned) {
			this.SubscriptionExpired=false; 
			console.log('SubscriptionExpired is false')
		  } 
		else{
			this.SubscriptionExpired=true; 
			console.log('SubscriptionExpired is true')
		}
		});
		
		// User closed the native purchase dialog
		this.store.when(this.productId2).cancelled((product) => {
		  console.error('Purchase was Cancelled');
		});
		
  
		// Handle error events
		this.store.when(this.productId2).error((err) => {
		console.log('Error occurred during purchase:', err);
		
		});
		// Do not finish subscription transactions here. The component that owns
		// the purchase must finish them only after its delivery work succeeds;
		// otherwise StoreKit cannot redeliver a transaction after an API failure.
	  
		// Refresh the product information
		this.store.refresh();
		
		}
	
		async playAudio(): Promise<void> {
			const platform = Capacitor.getPlatform();
			if (platform === 'android') return;
			if (platform === 'ios') {
				try {
				const { playing, shouldBeSilenced } = await NativeAudioPlayback.isOtherAudioPlaying();
				if (playing || shouldBeSilenced) return;
				} catch {
					// A failed native check must not interrupt audio in another app.
					return;
				}
			}
			const audioFile = 'assets/sounds/Intro.mp3';
			const sound = new Howl({
			  src: [audioFile],
			  autoplay: false,
			  volume: 1.0, // Initial volume level (0.0 to 1.0)
			});
		  
			// Start lowering the volume after 2 seconds
			setTimeout(() => {
			  // Gradually lower the volume over a duration of 2 seconds
			  sound.fade(1.0, 0.0, 3000);
			}, 2100);
			
			sound.play();
		}
		open_android_iab(loginUrl){
			const browser = window.open(loginUrl, '_blank', 'location=yes,toolbar=yes');

			const interval = setInterval(() => {
				if (browser?.closed) {
				clearInterval(interval);
				console.log('Window was closed.');
				}
			}, 500);
		  }
		  openCapacitor(){
			Swal.fire({
				title: 'Compatibility with other websites',
				text: `Some websites may reject connections from Laniakea. Do you want to open the browser?`,
				icon: 'info',
				//timer: 6900, // Show the alert for 3.9 seconds
				//timerProgressBar: true,
				toast: true,
				position: 'top-end',
				showCancelButton: true,
				confirmButtonText: 'Yes',
				cancelButtonText: 'No',
				color: '#ffffff',
				background: '#010f4e',
			  }).then((result) => {
				if (result.isConfirmed) {
				  // Call your desired function here
				  if (Capacitor.getPlatform() !== 'android') {
				  Browser.open({url:this.formService.valueInput['changingThisBreaksApplicationSecurity']});
				  }else{
					this.open_android_iab(this.formService.valueInput['changingThisBreaksApplicationSecurity']);
				  }
				}else{
					this.allowScrolling = true;
				}
			  });
			  this.allowScrolling = true;
		  }
		  displayLaniakea(){
			  this.laniakea_tv_loaded=true;
			  console.log('displayLaniakea called');
			this.formService.valueInput=this.sanitizer.bypassSecurityTrustResourceUrl('https://laniakea.tv/blog');
			this.allowScrolling = true;
		  }
		  updateMetaDescription(content: string): void {
			let metaDescription = document.querySelector('meta[name="description"]');
			if (metaDescription) {
				metaDescription.setAttribute('content', content);
			} else {
				metaDescription = document.createElement('meta');
				metaDescription.setAttribute('name', 'description');
				metaDescription.setAttribute('content', content);
				document.head.appendChild(metaDescription);
			}
		  }  
		  async enforceLatestVersion() {
			if (!this.platform.is('ios')) {
			  return; // ✅ Only check for iOS users
			}
			if (Capacitor.getPlatform() !== 'ios') {
				return;
			}
			try {
			  // ✅ Get installed version
			  const appInfo = await App.getInfo();
			  const installedVersion = appInfo.version;
			  console.log('⚡️ Installed App Version:', installedVersion);
		
			  // ✅ Get latest version from App Store

			  this.request.createRequestPost('getLatestIOS_version', {})
			  .then(response => {
				let data;
				if (typeof response === 'string') {
					 data = JSON.parse(response);
					}else{
						data=response;
					}
				console.log('getLatestIOS_version', data);
			
				//  console.warn('🚨 API did not return a valid version:', response);
				
		
			  const latestVersion =data.success
			  console.log('⚡️ Latest App Store Version:', latestVersion);
		
			  // ✅ Handle missing versions
			  if (!latestVersion) {
				console.warn('🚨 Failed to retrieve the latest version.');
				return;
			  }
		
			  // ✅ Compare versions and navigate if outdated
			  if (latestVersion > installedVersion) {
				this.formService.deprecated_ios_version=true;
				this.router.navigate([this.redirectPath]); // ✅ Redirect using Angular Router
				Swal.fire({
					title: 'Download the latest app version',
					text: `Your current app version is outdated and has been deprecated. Please update your app.`,
					icon: 'info',
					//timer: 6900, // Show the alert for 3.9 seconds
					//timerProgressBar: true,
					toast: true,
					position: 'top-end',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					cancelButtonText: 'No',
					color: '#ffffff',
					background: '#010f4e',
				  }).then((result) => {
					if (result.isConfirmed) {
					
					}else{
			
					}
				  });
			  } else {
				console.log('✅ App is up to date.');
			  }
			})
			.catch(error => {
				console.error('Error from API call:', error);  // Log error from API call
			});

			} catch (error) {
			  console.error('🚨 Error checking app version:', error);
			}
		  }

}
